import { mediaConstants } from "../constants";
import { mediaService } from "../../services";

export const mediaActions = {
  getMediaList,
  mediaUpload,
  mediaDelete,
};

function getMediaList(
  pageID = "",
  perPage = "",
  favorite = false,
  searchInput = ""
) {
  return (dispatch) => {
    dispatch(request());
    dispatch(loading(true));
    return mediaService
      .getMediaListResponse(pageID, perPage, favorite, searchInput)
      .then(
        (response) => {
          dispatch(success(response.data.body.files, response.data.body.data));
        },
        (error) => {
          dispatch(failure(error));
        }
      );
  };

  function request() {
    return { type: mediaConstants.GETALL_REQUEST };
  }
  function success(items, info) {
    return { type: mediaConstants.GETALL_SUCCESS, items, info };
  }
  function failure(error) {
    return { type: mediaConstants.GETALL_FAILURE, error };
  }
  function loading(loadingStatus) {
    return { type: mediaConstants.GETALL_LOADING, loadingStatus };
  }
}

function mediaUpload(file, title, path, fileIndex) {
  // console.log(fileIndex);
  return (dispatch) => {
    dispatch(request());
    dispatch(loading(true));
    return mediaService.MediaUploadRequest(file, title, path, fileIndex).then(
      (response) => {
        // console.log(response);
        dispatch(success(response));
      },
      (error) => {
        dispatch(failure([(error) => "failed"]));
      }
    );
  };

  function request() {
    return { type: mediaConstants.UPLOAD_REQUEST };
  }
  function success(callbackFileIndex) {
    return { type: mediaConstants.UPLOAD_SUCCESS, callbackFileIndex };
  }
  function failure(error) {
    return { type: mediaConstants.UPLOAD_FAILURE, error };
  }
  function loading(loadingStatus) {
    return { type: mediaConstants.UPLOAD_PROCESSING, loadingStatus };
  }
}

function mediaDelete(mediaID) {
  console.log(mediaID);
  return (dispatch) => {
    dispatch(request());
    dispatch(loading(true));
    return mediaService.MediaDeleteRequest(mediaID).then(
      (response) => {
        console.log(response);
        dispatch(success(response));
      },
      (error) => {
        dispatch(failure(error));
      }
    );
  };

  function request() {
    return { type: mediaConstants.UPLOAD_REQUEST };
  }
  function success(deleteCallback) {
    return { type: mediaConstants.UPLOAD_SUCCESS, deleteCallback };
  }
  function failure(error) {
    return { type: mediaConstants.UPLOAD_FAILURE, error };
  }
  function loading(loadingStatus) {
    return { type: mediaConstants.UPLOAD_PROCESSING, loadingStatus };
  }
}
